module.exports = __webpack_public_path__ + "static/img/_grry.e9c7b36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/_grry.png
// module id = CDyp
// module chunks = 96